<template>
    <div class="language-box">
        <el-switch v-model="status_value" @change="switchLanguage">
            <template #active-action>
              <span class="custom-action1">EN</span>
            </template>
            <template #inactive-action>
              <span class="custom-action2">中</span>
            </template>
          </el-switch>
          <div class="language-group">
              <span class="language-title">{{langrage.atNow}}：</span>
              <span class="language-text">{{languageName}}</span>
          </div>
    </div>
</template>

<script setup>
    import {
        ref,
        inject
    } from 'vue';
    const langrage = inject('langrage');
    
    const languageList = [{
            name: '中文',
            title: 'CN',
            value: 'chinese',
        },
        {
            name: 'English',
            title: 'EN',
            value: 'english',
        }
    ];
    
    const val = localStorage.getItem('langrage') || 'chinese';
    const status_value = ref(val === 'english');
    
    const switchLanguage = () => {
        const newLang = status_value.value ? 'english' : 'chinese';
        localStorage.setItem('langrage', newLang);
        sessionStorage.setItem('langrage', newLang);
        window.location.reload();
    }

    const languageName = languageList.find((item) => item.value == val) ?
        languageList.find((item) => item.value == val).name :
        '简体中文';
</script>

<style lang="less" scoped>
    .language-box {
        position: fixed;
        top: 2rem;
        right: 2rem;
        z-index: 100;
        display: flex;
        
        .custom-action1{
             font-size: 10px;
        }
        
        .custom-action2{
             color: #353f58;
        }
        
        .language-group {
            display: flex;
            padding: 0 6px;
            
            .language-title {
                font-size: 14px;
                white-space: nowrap;
                display: flex;
                align-items: center;
            }
            
            .language-text {
                font-size: 14px;
                white-space: nowrap;
                display: flex;
                align-items: center;
            }
        }
    }
    :v-deep {
        .el-switch__core {
            background: #11141c;
        }
    }
    /* ============== RESPONSIVE - 移动端 (max-width: 768px) ============== */
    @media screen and (max-width: 768px) {
        .language-group {
            color: #fff;
        }
    }
</style>